// pages/ProformaGeneratorPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Space, message, Grid } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import ProformaGenerator from '../components/Orders/ProformaGenerator';
import api from '../services/api';

const ProformaGeneratorPage = () => {
  const navigate = useNavigate();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    // Fetch orders and customers
    const fetchData = async () => {
      try {
        const [ordersData, customersData] = await Promise.all([
          api.get('/orders?limit=1000'),
          api.get('/customers')
        ]);

        const allOrders = ordersData.data || [];
        setOrders(allOrders);
        setCustomers(customersData.data || []);
      } catch (error) {
        message.error('Failed to load data');
      }
    };

    fetchData();
  }, []);

  return (
    <div style={{ padding: isMobile ? '12px' : '24px' }}>
      <Card bodyStyle={{ padding: isMobile ? '12px' : '24px' }}>
        <Space direction="vertical" style={{ width: '100%' }} size={isMobile ? 'small' : 'large'}>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/msedcl')}
            size={isMobile ? 'small' : 'middle'}
          >
            {isMobile ? 'Back' : 'Back to MSEDCL Dashboard'}
          </Button>

          <ProformaGenerator
            visible={true}
            onCancel={() => navigate('/msedcl')}
            orders={orders}
            customers={customers}
          />
        </Space>
      </Card>
    </div>
  );
};

export default ProformaGeneratorPage;